import { QueryClient } from '@tanstack/react-query';

/**
 * Shared React Query client.
 *
 * Defaults tuned for the iCGChat console:
 *   - `staleTime: 30_000` — most console queries (agents, accounts, conversation
 *     metadata) tolerate ~30s of staleness; real-time updates come via the
 *     WebSocket channel (M5-T6), not aggressive refetching.
 *   - `retry: 1` — one quiet retry on transient network blips, then surface.
 *   - `refetchOnWindowFocus: false` — the WebSocket keeps us live; refocus
 *     refetch would just spam the Hub.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
